import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28.51",
  height: "25.158"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8136",
  d: "M84 45.277v7.34h28.5v-7.34zm6.562 2.646a1.025 1.025 0 1 1-.724.3 1.025 1.025 0 0 1 .724-.3zm7.36.22h9.012a.8.8 0 1 1 0 1.6h-9.012a.8.8 0 0 1 0-1.6zM84 54.206v7.34h28.51v-7.34zm6.562 2.639a1.025 1.025 0 1 1-.724.3 1.025 1.025 0 0 1 .724-.3zm7.36.233h9.012a.8.8 0 1 1 0 1.6h-9.012a.8.8 0 0 1 0-1.6zM84 63.128v7.307h28.51v-7.307zm6.562 2.645a1.025 1.025 0 1 1-.725.3 1.024 1.024 0 0 1 .725-.3zm7.36.233h9.012a.8.8 0 1 1 0 1.6h-9.012a.8.8 0 0 1 0-1.6z",
  transform: "translate(-84 -45.277)",
  style: {"fill":"#f59600"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };